module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NyA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zNy4xOTUyIDQ0LjA3NjJMMC44MzAzNjEgNC45NDM2Mkw0Ni40OTg2IDAuMjcxNzU2TDM3LjE5NTIgNDQuMDc2MloiIGZpbGw9IiNFNkY2RkYiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/polygon.svg
// module id = 142
// module chunks = 1